import { Base } from "@/components/Product/energyLabel/base";
import { Fiche } from "@/components/Product/energyLabel/components/fiche";
import { Label } from "@/components/Product/energyLabel/components/label";
import { LabelNested } from "@/components/Product/energyLabel/components/labelNested";

export const EnergyLabel = Object.assign(Base, {
    LabelNested: LabelNested,
    Label: Label,
    Fiche: Fiche
});
